import { useEffect } from 'react';

import { useAuth } from '@sine/auth-client';
import { useTeamSwitcher } from '@sine/sine-team-switcher';

import rxEventHub, { RxEvent } from '../../../../services/events/rx';
import teamSwitcherService from '../../../../team/teamSwitcher.service';
import useTrialDataQuery from '../../../customHooks/useTrialData.hook';
import TrialBanner from './TrialBanner';

export default function BannerComponent() {
  const { userDetails, authState } = useAuth();
  const { isLoading: isLoadingCurrentTeam } = useTeamSwitcher();

  // We cannot swap this to the `useTeamSwitcher` hook as this component mounts before the team switcher is loaded (sometimes).
  const currentTeam = teamSwitcherService.getCurrentTeam();

  const { refetchTrialData } = useTrialDataQuery(userDetails?.verify.email.completed, currentTeam?.id);

  useEffect(() => {
    const subscriptions = [
      rxEventHub.on(RxEvent.TRIAL_DATA_LOADING, () => refetchTrialData()),
      rxEventHub.on(RxEvent.TEAM_CHANGED, () => refetchTrialData()),
      rxEventHub.on(RxEvent.LICENCE_UPDATED, () => refetchTrialData()),
      rxEventHub.on(RxEvent.SITE_ADDED, () => refetchTrialData()),
      rxEventHub.on(RxEvent.BILLING_MODE_UPDATED, () => refetchTrialData()),
    ];

    return () => subscriptions.forEach((sub) => sub.unsubscribe());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoadingCurrentTeam || authState !== 'loggedIn') return null;

  return <TrialBanner />;
}
